<ngb-rating [(rate)]="rate" readonly="true" max="5" class="rating" (click)="getRatingValue()"></ngb-rating>